/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Save_SuccessInputs */

const en_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording saved successfully!`)
};

const fr_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement sauvegardé avec succès !`)
};

const de_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme erfolgreich gespeichert!`)
};

const it_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione salvata con successo!`)
};

const ru_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись успешно сохранена!`)
};

const es_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Grabación guardada exitosamente!`)
};

const zh_cn2_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制保存成功！`)
};

const ja_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録音が正常に保存されました。`)
};

const hi_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग सफलतापूर्वक सहेज ली गई!`)
};

const pt_pt2_audio_recorder_save_success = /** @type {(inputs: Audio_Recorder_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravação salva com sucesso!`)
};

/**
* | output |
* | --- |
* | "Recording saved successfully!" |
*
* @param {Audio_Recorder_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_save_success = /** @type {((inputs?: Audio_Recorder_Save_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Save_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_save_success(inputs)
	if (locale === "de") return de_audio_recorder_save_success(inputs)
	if (locale === "it") return it_audio_recorder_save_success(inputs)
	if (locale === "ru") return ru_audio_recorder_save_success(inputs)
	if (locale === "es") return es_audio_recorder_save_success(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_save_success(inputs)
	if (locale === "ja") return ja_audio_recorder_save_success(inputs)
	if (locale === "hi") return hi_audio_recorder_save_success(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_save_success(inputs)
	return en_audio_recorder_save_success(inputs)
});